import React from 'react';

import styles from './AvailableBids.css';
import Results from './Results';
import SearchForm from './SearchForm';

const AvailableBids = ({
  activeCrew,
  customers,
  detailEnabled,
  dropdowns,
  form,
  bids,
  loading,
  locationEnabled,
  onCustomerSearch,
  onBidClick,
  onFormUpdate,
}) => (
  <div className={styles.container}>
    <SearchForm
      customers={customers}
      dropdowns={dropdowns}
      form={form}
      loading={loading}
      onCustomerSearch={onCustomerSearch}
      onFormUpdate={onFormUpdate}
    />
    <Results
      activeCrew={activeCrew}
      bids={bids}
      className={styles.results}
      detailEnabled={detailEnabled}
      loading={loading}
      locationEnabled={locationEnabled}
      onBidClick={onBidClick}
    />
  </div>
);

export default AvailableBids;
